import { render } from "./AppHeader.vue?vue&type=template&id=12d0b970&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=12d0b970&scoped=true&lang=css"

import exportComponent from "/home/gremmel/prog/nodejs/bgg-statistic/ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d0b970"]])

export default __exports__